import { Form, Image, Input, Row } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { LiteralUnion } from 'antd/lib/_util/type';
import { ColProps } from 'antd/lib/col';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import React, { ReactNode, useContext } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import InfoTooltip from 'components/molecules/InfoTooltip';

import getLanguageObject from 'utils/getLanguageObject';
import nepovoleneZnakyValidation from 'utils/validations/nepovoleneZnakyValidation';

const { Item } = Form;

interface IInputTextArea extends TextAreaProps {
    label?: string;
    labelAlign?: 'left' | 'right';
    name: string;
    className?: string;
    type?: LiteralUnion<'text' | 'password' | 'email' | 'tel' | string>; // Dle potreby lze pridat dalsi typy
    initialValue?: string | number;
    rules?: Rule[]; // Pro ted disabled nevime co vse budeme potrebovat a jak to budeme zapisovat
    idCaptcha?: number;
    dependencies?: NamePath[]; // pouzit napr pri validacii 2 poli ktore suvisia = heslo / heslo overeni
    imageCaptcha?: string;
    extramessage?: string;
    /** Urcuje sirku labelu */
    labelCol?: ColProps;
    infoTooltipText?: string | ReactNode;
    notRequired?: boolean;
    validateTrigger?: string | string[];
    hide?: boolean; // ak nechceme zobrazit komponentu ale ponechat jej value
    validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined;
    usePscFormater?: boolean;
    disableEdit?: boolean;
    capitalize?: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    labelExtra?: any;
    // message?: string;
    // maxLength?: number;
    // validation: ((form: FormInstance) => RuleObject); // Potrba vyresit validator, bud najit zpusob jak to rozdelit (TypeScript) nebo posilat v rules
}
// Zakladni Input componenta, TODO mozne pripojeni na context pro nacitani a zapisovani dat
const InputTextArea: React.FC<IInputTextArea> = props => {
    const { language } = useContext(Context);
    const {
        label,
        labelAlign,
        name,
        className = '',
        initialValue,
        idCaptcha = 0,
        imageCaptcha,
        dependencies = [],
        rules = nepovoleneZnakyValidation(),
        notRequired,
        extramessage = '',
        labelCol,
        validateTrigger,
        validateStatus,
        onChange,
        onBlur,
        hide,
        usePscFormater,
        capitalize,
        infoTooltipText = '',
        disableEdit,
        labelExtra,
        ...rest
    } = props;

    return (
        <>
            {!!idCaptcha && (
                <Row justify="start">
                    <Image
                        id={idCaptcha.toString()}
                        alt="captcha"
                        src={imageCaptcha}
                        style={{
                            marginBottom: '10px'
                        }}
                        preview={false}
                    />
                </Row>
            )}
            <Item
                label={
                    label ? (
                        <>
                            <Paragraph text={label} strong={true} disableEdit={disableEdit} />{' '}
                            {infoTooltipText && <InfoTooltip title={infoTooltipText} />} {labelExtra && labelExtra}
                        </>
                    ) : null
                }
                hidden={hide}
                labelAlign={labelAlign}
                className={className}
                name={name}
                initialValue={initialValue}
                dependencies={dependencies}
                rules={
                    notRequired
                        ? rules
                        : [
                              {
                                  required: true,
                                  message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                              },
                              ...rules
                          ]
                }
                extra={<Paragraph text={extramessage} className="extramessage-text" />}
                labelCol={labelCol}
                validateTrigger={validateTrigger}
                validateStatus={validateStatus}
                normalize={
                    usePscFormater
                        ? (value: string) => {
                              const splitVal = value.replace(/\s/g, '').split('');
                              splitVal.length > 3 && splitVal[3] !== ' ' && splitVal.splice(3, 0, ' ');
                              return splitVal.length > 3 ? splitVal.join('') : value;
                          }
                        : capitalize
                          ? (value: string) => value.toUpperCase()
                          : (value: string) => value.replace(/\s+/g, ' ')
                }
            >
                <Input.TextArea
                    placeholder={props.disabled ? '' : getLanguageObject(language).VYPLNTE_PLACEHOLDER || 'Vyplňte...'}
                    className="input-component"
                    onChange={onChange}
                    onBlur={onBlur}
                    style={{
                        ...props.style,
                        borderRadius: 6
                    }}
                    {...rest}
                />
            </Item>
        </>
    );
};

export default InputTextArea;
